import { Col, Form, Row } from "antd";
import Axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import { ReactComponent as Right } from "../../../static/arrowRight.svg";
import "./institution.scss";

const mapDispatchToProps = (dispatch) => {
  return {};
};
class ConnectedTeams extends Component {
  state = {
    name: "",
  };

  componentDidMount() {
    this.props.openKeyboard();
  }

  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  submitForm = async () => {
    await Axios.post("/1.0.0/game/team", {
      categoryId: this.props.categoryId,
      institutionId: this.props.institutionId,
      email: null,
      name: this.props.teamName,
    })
      .then((response) => {
        this.props.setTeamId(response.data.id);
      })
      .catch((err) => {
        console.log(err);
      });
    this.props.next();
  };

  render() {
    const formItemLayout = {
      labelCol: {
        xs: {
          span: 24,
        },
        sm: {
          span: 24,
        },
      },
      wrapperCol: {
        xs: {
          span: 24,
        },
        sm: {
          span: 24,
        },
      },
    };
    return (
      <div>
        <Form
          ref={this.props.formRef}
          {...formItemLayout}
          name="team"
          onFinish={this.submitForm}
          scrollToFirstError
          layout="vertical"
          //wrapperCol={{ style: { padding: "0", margin: "0 0 0 0" } }}
        >
          <Row>
            <Col span={18} style={{ padding: "1.5em" }}>
              <Form.Item
                //label={<strong>E-mail:</strong>}
                name="teamName"
                rules={[
                  {
                    required: true,
                    message: "Kérem adja meg a csapata nevét",
                  },
                ]}
              >
                <input
                  id="teamName"
                  name="teamName"
                  onChange={this.props.change}
                  value={this.props.teamName}
                  onFocus={this.props.setInputName}
                  style={{ width: "100%" }}
                  className="inst-input-field"
                  placeholder="Csapatnév"
                />
              </Form.Item>
            </Col>
            <Col span={4} style={{ padding: "1.5em" }}>
              <Form.Item>
                <button type="submit" className="inst-next-button">
                  Következő <Right className="inst-arrow-icon" />
                </button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
        {/* <Form
          ref={this.props.formRef}
          {...formItemLayout}
          name="team"
          onFinish={this.submitForm}
          scrollToFirstError
          layout="vertical"
          //wrapperCol={{ style: { padding: "0", margin: "0 0 0 0" } }}
        >
          <Form.Item
            label={<strong>Csapat neve:</strong>}
            name="teamName"
            rules={[
              {
                required: true,
                message: "Kérem adja meg a csapat nevét!",
              },
            ]}
          >
            <Input
              id="teamName"
              name="teamName"
              onChange={this.props.change}
              value={this.props.teamName}
              onFocus={this.props.setInputName}
            />
          </Form.Item>
          <Form.Item>
            <Button
              danger
              onClick={this.props.prev}
              style={{ marginRight: "0.5em" }}
            >
              Vissza
            </Button>
            <Button
              type="primary"
              danger
              htmlType="submit"
              style={{ marginLeft: "0.5em" }}
            >
              Következő
            </Button>
          </Form.Item>
        </Form> */}
      </div>
    );
  }
}
const mapStateToProps = (state) => ({});
const Teams = connect(mapStateToProps, mapDispatchToProps)(ConnectedTeams);
export default Teams;
